import { render } from "./CallSurvey.vue?vue&type=template&id=2334f6e5&ts=true"
import script from "./CallSurvey.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallSurvey.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/components/CallSurvey.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2334f6e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2334f6e5', __exports__)) {
    api.reload('2334f6e5', __exports__)
  }
  
  module.hot.accept("./CallSurvey.vue?vue&type=template&id=2334f6e5&ts=true", () => {
    api.rerender('2334f6e5', render)
  })

}


export default __exports__